import { normalizeObject, dataLayerPush } from "../shared/utils";
var bibLookupFail = function (e) {
    var bib_number = ((e === null || e === void 0 ? void 0 : e.detail) || {}).bib_number;
    var dataLayerEventData = {
        error_message: "child_not_found_for_".concat(bib_number),
        error_type: "bib_lookup_error",
        event: "error_view",
        event_action: "error_view",
        event_category: "bib_lookup_error",
        event_errors: 1,
        event_label: "child_not_found_for_".concat(bib_number),
        non_interaction: true,
        total_errors: 1
    };
    dataLayerPush(normalizeObject(dataLayerEventData));
};
var bibLookupSuccess = function (e) {
    var bib_number = ((e === null || e === void 0 ? void 0 : e.detail) || {}).bib_number;
    var dataLayerEventData = {
        event: "bib_lookup_success",
        event_action: "bib_lookup_success",
        event_category: "bib_lookup",
        event_label: bib_number,
        non_interaction: true
    };
    dataLayerPush(normalizeObject(dataLayerEventData));
};
export { bibLookupFail, bibLookupSuccess };
